import React from "react";

function CollectionSpotifyEmbed() {
  const src = 'https://open.spotify.com/embed/album/2yMfaynthtWVAkJ5A3Kwrf?utm_source=generator';
  return (
    <div className="CollectionCortisYoutube-embed">
      <iframe
        data-testid="embed-iframe"
        className="CollectionCortisYoutube-iframe"
        style={{ borderRadius: "12px" }}
        src={src}
        width="100%"
        height="152"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
    </div>
  );
}

export default React.memo(CollectionSpotifyEmbed);
